module.exports = "/_next/static/media/8a5ee11d38a2379d5506a55dec33269c.svg";